import { render, staticRenderFns } from "./abnormalReporting.vue?vue&type=template&id=28371ec0&"
import script from "./abnormalReporting.vue?vue&type=script&lang=js&"
export * from "./abnormalReporting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports